import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { articleNumber } from '../Actions/Product.action';

export default function SizeSelector() {
    const dispatch = useDispatch();
    const myPage = useSelector((state) => state.myPage);
    const product = useSelector((state) => state.product);
    const isResellerSite = window.__litium.requestContext.isResellerSite;
    const sizes = Array.isArray(product?.sizes) ? product.sizes : [];

    const updateRecommendedRetailPrice = (recommendedRetailPrice) => {
        const recommendedPriceContainer = document.querySelector('[data-recommended-retail-price]');
        if (!recommendedPriceContainer) {
            return;
        }

        const recommendedPriceValue = recommendedPriceContainer.querySelector('.product-detail__recommended-price-value');
        if (!recommendedPriceValue) {
            return;
        }

        const hasRecommendedRetailPrice = !!recommendedRetailPrice;
        recommendedPriceValue.textContent = recommendedRetailPrice || '';
        recommendedPriceContainer.classList.toggle('is-hidden', !hasRecommendedRetailPrice);
    };

    const setArticleNumberAndPrice = (item, shouldDispatch = true) => {
        if (!item) {
            return;
        }

        if (shouldDispatch) {
            dispatch(articleNumber(item.articleNumber, item.disabled));
        }
        const reviewInput = document.getElementById('productReviewCurrentArticleNumber');
        if (reviewInput) {
            reviewInput.value = item.articleNumber;
        }
        const variantIdElement = document.getElementById('productVariantArticleNumberValue');
        if (variantIdElement) {
            variantIdElement.textContent = item.articleNumber;
        }
        window.dispatchEvent(
            new CustomEvent('product-review:variant-changed', {
                detail: {
                    articleNumber: item.articleNumber,
                },
            })
        );

        if (document.getElementsByClassName('product__campaign-price').length > 0) {
            var campaignPrice = document.getElementsByClassName('product__campaign-price')[0];
            campaignPrice.innerHTML = item.campaignPrice;
        }

        if (document.getElementsByClassName('product__old-price').length > 0) {
            var campaignPrice = document.getElementsByClassName('product__old-price')[0];
            campaignPrice.innerHTML = item.price;
        }

        if (document.getElementsByClassName('price').length > 0) {
            var campaignPrice = document.getElementsByClassName('price')[0];
            campaignPrice.innerHTML = item.price;
        }

        updateRecommendedRetailPrice(item.recommendedRetailPrice);
    };

    useEffect(() => {
        const activeItem = sizes.find((item) => item.articleNumber === product.currentArticleNumber) ||
            sizes.find((item) => !item.disabled) ||
            sizes[0];

        setArticleNumberAndPrice(activeItem, false);
    }, [product.currentArticleNumber, sizes]);

    return (
        <ul className="product-detail__variant-size" data-filter="sizefilter" id="sizefilter">
            {sizes.map((item) => {
                return (
                    <li className="product-detail__selector-item" key={item.articleNumber}>
                        <button
                            className={`product-detail__selector-size ${product.currentArticleNumber === item.articleNumber ? 'is-active' : ''} ${item.disabled && !isResellerSite ? 'is-disabled-private' : ''}`}
                            type="button"
                            data-article-number={item.articleNumber}
                            data-size={item.size}
                            data-price={item.price}
                            data-campaign-price={item.campaignPrice}
                            data-recommended-retail-price={item.recommendedRetailPrice}
                            disabled={item.disabled}
                            onClick={() => setArticleNumberAndPrice(item)}
                        >
                            {item.name}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}
